import { React, useState, useContext } from "react";
import { GlobalContext } from "../Context/GlobalState";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Login.css"
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

function Login() {


  const { setUser, setLogin, setUserKredi,API_URL } = useContext(GlobalContext);

  const [alert, setAlert] = useState("");
  const navigate = useNavigate();
  const [values, setValues] = useState({
    email: "",
    password: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(API_URL + "/login", values)
      .then((res) => {
        if (res.data.length > 0) {
          setAlert("Giriş Başarılı");
          //console.log(res);
          window.localStorage.setItem("user", res.data[0].email);
          window.localStorage.setItem("isAuth", true);
          setLogin(true);
          setUser(res.data[0].email);
          setUserKredi(res.data[0].kredi);
          navigate("/home");
        } else {
          setAlert("Kullanıcı Adı veya Şifre Yanlış");
        }
      })
      .catch((error) => {
        console.log(error.data);
      });
  };

  const handleInput = (e) => {
    setValues((prev) => ({ ...prev, [e.target.name]: [e.target.value] }));
  };

  return (
    <>
      <div className="d-flex vh-100 divBackground justify-content-center align-items-center">
        <div className="col-6 mt-3 text-center">
          <div>
            <h1 className="main-heading">
              Rapor Yazmanın En Kolay Yoluna Hoşgeldiniz...
            </h1>
            <h2 className="sub-heading mt-5">
              Bu Site Siz Değerli Ziraat Bilirkişilerinin Raporlama İşlerini
              Hızlandırıp Standartlaştırmak Üzere Hazırlanmıştır.
            </h2>
          </div>
        </div>
        <div className="col-4 mt-5">
          <div className="bg-white mt-1 rounded p-3 mx-5 login-panel">
            <h2>Giriş Yap</h2>
            <form onSubmit={handleSubmit}>
              <div className="my-2">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="Email"
                  className="form-control"
                  onChange={handleInput}
                  autoComplete="current-email"
                />
              </div>
              <div className="my-2">
                <label htmlFor="password">Şifre</label>
                <input
                  type="password"
                  name="password"
                  placeholder="Şifre"
                  required
                  className="form-control"
                  onChange={handleInput}
                  autoComplete="current-password"
                />
              </div>
              <p style={{ color: "red" }}>
                <strong>{alert}</strong>
              </p>
              <button className="btn btn-success w-100 my-2" type="submit">
                Giriş Yap
              </button>
              <Link
                to={"/register"}
                className="btn btn-secondary w-100"
                type="submit"
              >
                Kayıt Ol
              </Link>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;

